var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconItem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4846 10.8477V9.68933C11.4846 8.4539 12.6221 8.29944 13.2288 7.68173C13.9114 6.98669 13.7597 5.67413 13.0771 5.05641C12.3188 4.28429 10.4989 4.67025 10.0439 5.51971C9.66463 6.21475 8.6789 5.59701 9.058 4.97914C9.89222 3.43483 12.6221 2.97154 13.9114 4.20701C14.8973 5.28802 15.1247 7.21848 14.139 8.29948C13.8356 8.68565 12.5465 9.30335 12.5465 9.68937V10.9248L22.7078 16.6391C24.0727 17.4112 24.7553 19.7277 22.7078 20.5H1.32319C-0.800066 19.7279 -0.0417784 17.4114 1.32319 16.6391L11.4846 10.8477ZM12.0155 12.006L1.9299 17.7203C1.47491 17.952 0.868266 18.8013 1.55065 19.1874H22.4045C23.0871 18.8013 22.4804 17.952 22.0252 17.7203L12.0155 12.006Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconItem);
export default __webpack_public_path__ + "static/media/icon-item.425c9cfbac65f1e69a4432fbf0759a63.svg";
export { ForwardRef as ReactComponent };